module.exports = __webpack_public_path__ + "static/media/salli_english_us.46a6712d.mp3";